import React, { useState, Fragment, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Table, Drawer, Popconfirm, Switch,
} from 'antd';
import { EditOutlined, DeleteOutlined } from '@ant-design/icons';
import H3Text from '@Uilib/h3Text';
import H3Image from '@Uilib/h3Image';
import Helpers from '@Apis/helpers';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import closeIcon from '@Images/icons/icon-close-blue.png';
import TdsTcsActions from '@Actions/configurations/tdsTcsActions';
import TdsTcsForm from './TdsTcsForm';
import './style.scss';

const TdsTcs = ({
  tdsTcs, getTdsTcsLoading, user, getTdsTcs, deleteTdsTcs, deleteTdsTcsLoading,
}) => {
  const [isUserReady, setIsUserReady] = useState(false);
  const [showNewTdsTcsModal, setShowNewTdsTcsModal] = useState(false);
  const [showUpdateTdsTcsModal, setShowUpdateTdsTcsModal] = useState(false);
  const [searchKeyword, setSearchKeyword] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [selectedTdsTcs, setSelectedTdsTcs] = useState('');

  const columns = [
    {
      title: 'TAX NAME',
      key: 'name',
      render: (text, record) => `${record?.tax_name || '-'}`,
    },
    {
      title: 'TAX TYPE',
      key: 'name',
      render: (text, record) => `${record?.tax_type_name || '-'}`,
    },
    {
      title: 'RATE(%)',
      render: (text, record) => (
        <Fragment>
          {`${record?.tax_value}%` || '-'}
        </Fragment>
      ),
    },
    {
      title: 'SECTION',
      render: (text, record) => (
        <Fragment>
          {record?.description || '-'}
        </Fragment>
      ),
    },
    {
      title: '',
      key: 'action',
      render: (text, record) => (
        <div style={{
          textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center',
        }}
        >
          <div
            className="roundIconButton"
            onClick={() => {
              setShowUpdateTdsTcsModal(true);
              setSelectedTdsTcs(record);
            }}
          >
            <EditOutlined />
          </div>
          <Popconfirm
            placement="topRight"
            title="Are you sure you want to delete this tax?"
            onConfirm={() => deleteTdsTcs({ tax_id: record?.tax_id }, () => {
              getTdsTcs();
            })}
            okText="Yes"
            cancelText="No"
          >
            <div className="deleteButton">
              {' '}
              <DeleteOutlined />
              {' '}
            </div>
          </Popconfirm>
        </div>
      ),
    },
  ];

  useEffect(() => {
    if (user && !isUserReady) {
      getTdsTcs(currentPage, limit);
      setIsUserReady(true);
    }
  }, []);

  return (
    <Fragment>
      <div className="tdsTcs__wrapper">
        <div className="ant-row">
          <div className="ant-col-md-24">
            <div className="tdsTcs__table__wrapper">
              <div className="tdsTcs__table__data hide__in-mobile">
                <Table
                  title={() => (
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                      {`${tdsTcs?.data?.length || '0'} Total TDS/TCS`}
                      {Helpers.getPermission(Helpers.permissionEntities.VENDORS,
                        Helpers.permissionTypes.CREATE, user) && (
                        <H3Button
                          buttonType={defaultButtonTypes.BLUE_ROUNDED}
                          text="+ New TDS/TCS"
                          onClick={() => setShowNewTdsTcsModal(true)}
                          customClass="tdsTcs__header__add-button hide__in-mobile"
                        />
                      )}
                    </div>
                  )}
                  loading={getTdsTcsLoading || deleteTdsTcsLoading}
                  showHeader
                  size="small"
                  scroll="scroll"
                  columns={columns}
                  dataSource={tdsTcs?.data || []}
                  pagination={tdsTcs?.count > limit ? {
                    defaultCurrent: 1,
                    current: currentPage,
                    total: tdsTcs ? tdsTcs?.count : 0,
                    pageSize: limit,
                    onChange: (page) => {
                      setCurrentPage(page);
                      getTdsTcs(page, limit);
                    },
                    position: ['bottomRight'],
                    showSizeChanger: false,
                  } : false}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <Drawer
        open={showNewTdsTcsModal}
        width="360px"
        mask
        onClose={() => setShowNewTdsTcsModal(false)}
        destroyOnClose
      >
        <div className="custom-drawer__header-wrapper">
          <div className="custom-drawer__header" style={{ width: '315px' }}>
            <H3Text text="Add New TDS/TCS" className="custom-drawer__title" />
            <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => setShowNewTdsTcsModal(false)} />
          </div>
        </div>
        <div className="create-po__new-vendor-wrapper">
          <TdsTcsForm
            callback={() => {
              getTdsTcs();
              setShowNewTdsTcsModal(false);
            }}
          />
        </div>
      </Drawer>
      <Drawer
        title="Update TDS/TCS"
        open={showUpdateTdsTcsModal}
        onClose={() => setShowUpdateTdsTcsModal(false)}
        width="360px"
        destroyOnClose
      >
        <div className="custom-drawer__header-wrapper">
          <div className="custom-drawer__header" style={{ width: '315px' }}>
            <H3Text text="Update TDS/TCS" className="custom-drawer__title" />
            <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => setShowUpdateTdsTcsModal(false)} />
          </div>
        </div>
        <TdsTcsForm
          selectedTdsTcs={selectedTdsTcs}
          callback={() => {
            getTdsTcs();
            setShowUpdateTdsTcsModal(false);
          }}
        />
      </Drawer>
    </Fragment>
  );
}; const mapStateToProps = ({
  UserReducers, TdsTcsReducers,
}) => ({
  user: UserReducers.user,
  getTdsTcsLoading: TdsTcsReducers.getTdsTcsLoading,
  deleteTdsTcsLoading: TdsTcsReducers.deleteTdsTcsLoading,
  tdsTcs: TdsTcsReducers.tdsTcs,
});

const mapDispatchToProps = (dispatch) => ({
  getTdsTcs: (page, limit) => dispatch(TdsTcsActions.getTdsTcs(page, limit)),
  deleteTdsTcs: (payload, callback) => dispatch(TdsTcsActions.deleteTdsTcs(payload, callback)),
});

TdsTcs.propTypes = {
  user: PropTypes.any,
  getTdsTcs: PropTypes.func,
  deleteTdsTcs: PropTypes.func,
  getTdsTcsLoading: PropTypes.bool,
  deleteTdsTcsLoading: PropTypes.bool,
  tdsTcs: PropTypes.any,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(TdsTcs));
